import React, { lazy } from 'react';
// import Loader from '../Loader/Loader.lazy';

const LazyMap = lazy(() => import('./Map.js'));

const Map = (props) => <LazyMap {...props} />;

export default Map;
